export function replacePlaceholderContent(template: string | undefined, replacements: Record<string, string>): string {
  if (!template) return '';

  return Object.entries(replacements).reduce(
    (result, [placeholder, value]) => result.replace(placeholder, value),
    template
  );
}
